/* eslint-disable consistent-return */
import { setBattleResultState } from '../../actions/game/gameState.actions'
import STAGES from '../../../constants/STAGES'

const progressionMiddleware = ({ getState, dispatch }) => next => (action) => {
    const { payload, meta } = action
    const { checkProgress } = meta || {}

    if (!checkProgress) {
        return next(action)
    }

    const { progress: { stageID, outcome } } = payload
    const [chapterString, sectionString] = stageID.split('-')
    const chapter = parseInt(chapterString, 10)
    const section = parseInt(sectionString, 10)
    const { progression: { stages } } = getState()
    const currentStatus = stages[chapter][section]

    if (!currentStatus) {
        console.log('catch 23!')
        return false
    }

    const calculatedProgress = {
        stageID,
        chapter,
        section,
        outcome: (
            (outcome === 'lost')
                ? outcome
                : (currentStatus === 'cleared') ? 'repeat' : 'first'
        ),
        status: (
            (currentStatus === 'cleared')
                ? currentStatus
                : (outcome === 'won') ? 'cleared' : 'failed'
        ),
        nextStage: false,
    }

    if (
        outcome === 'won'
        && (
            currentStatus === 'new'
            || currentStatus === 'failed'
        )
    ) {
        const nextStage = STAGES[`${chapter}-${section + 1}`]
            || STAGES[`${chapter + 1}-${1}`]
            || { ID: 'ToBeContinued' }
        calculatedProgress.nextStage = nextStage.ID
    }

    dispatch(setBattleResultState(calculatedProgress.outcome))

    return next({ ...action, payload: calculatedProgress })
}

export default progressionMiddleware
